import { LoaderCircle } from "lucide-react";

export default function LoadingFullscreen() {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            style={{ minHeight: '100vh', minWidth: '100vw' }}
        >
            <div className="flex flex-col items-center">
                <LoaderCircle className="animate-spin text-white" size={48} />
                <span className="mt-4 text-white text-lg font-semibold">Đang tải...</span>
            </div>
        </div>
    );
}
